const POSSIBLE_FILTERS = {
  selectedYear: 'All',
  entityFilter: 'All',
  questionnaireType: 'All',
  questionnaireStatus: -1,
  questionnaireStatusIncludeLocked: true,
  selectedAssignedUser: -1,
  selectedPreparerUser: -1,
  selectedClientManagerUser: -1,
  selectedSender: -1,
  selectedClientTagsFilter: [],
  selectedEntityTagsFilter: [],
  selectedFirmGroup: -1,
  selectedFirmCustomStatusFilter: [],
  hideInactive: false,
};

export const defaultOverviewFilterSet = {
  overview: POSSIBLE_FILTERS,
  clients: POSSIBLE_FILTERS,
  entities: POSSIBLE_FILTERS,
};
